import * as React from "react";
import { Redirect, Route, Switch } from "react-router";

import { MessageDetail } from "./message-details/details/messageDetail";
import { MessageListing } from "./message-listing/messageListing";
import { MessageListingProvider } from "./message-listing/_infra/messageListingProvider";
import { useMessagingStyles } from "./styles";

export const MessageCenterContainer = React.memo(() => {
    const classes = useMessagingStyles({});

    return (
        <div className={classes.root}>
            <Switch>
                <Route
                    path="/messages/:messageId(\d+)"
                    render={() => <MessageDetail />}
                />
                <Route
                    path="/messages/:messageId"
                    render={() => <Redirect to="/messages" />}
                />
                <Route
                    path="/messages"
                    render={() => (
                        <MessageListingProvider>
                            <MessageListing />
                        </MessageListingProvider>
                    )}
                />
            </Switch>
        </div>
    );
});
